import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { selectedConsumerList, setBatch, setEndDate, setSelectedAmount, setStartDate } from "../../redux/misc-data/misc-data.action";
import history from "../../auth/history";
import { store } from '../../redux/store';
import { v4 as uuidv4 } from 'uuid';
class TotalBill extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
        }
    }

    componentDidMount() { }
    componentWillUnmount() {
    }



    pay = (event) => {
        event.preventDefault();

        setTimeout(() => {
            var goToBillList=document.getElementById('goToBillList');
            goToBillList.click();

        }, 200);

    }

    goToBillList = (event) => {
        event.preventDefault();
        store.dispatch(setStartDate(''));
        store.dispatch(setEndDate(''));

        setTimeout(() => {
           var goToBillList=document.getElementById('goToBillList');
           goToBillList.click();

        }, 200);

    }
    render() {

        return (
            <div class="totalbill">
                <Link to='/bill-list'>
                    <button id="goToBillList" hidden={true}></button>
                </Link>
                <Link to="/payment">
                    <button id="gotoPaymentPgae" hidden={true}></button>
                </Link>
                <div class="row">
                    <div class="col-6 col-sm-3 order-sm-1">
                        <div class="ttlbiltxt">
                            <p>Total Bill Count</p>
                            <h5>{this.props.selectedConsumers.length}</h5>
                        </div>
                    </div>

                    <div class="col-6 col-sm-3 order-sm-2">
                        <div class="ttlbiltxt rtxt">
                            <p>Total Bill Amount</p>
                            <h5>₹ {this.props.selectedAmount}</h5>
                        </div>
                    </div>

                    <div class="col-6 col-sm-4 order-sm-4">
                        {/* <Link to='/bill-list'> */}
                        <div class="ttlbiltxt">
                            <button class="lbbtn" onClick={this.goToBillList}
                            title={'View All Bills'}
                            >View All</button>
                        </div>
                        {/* </Link> */}


                    </div>
                    <div class="col-6 col-sm-2 order-sm-3">
                
                    

                        <div class="ttlbiltxt rtxt">
                            <button class="dbbtn" onClick={this.pay}
                            disabled={(this.props.selectedAmount>0 &&
                                this.props.selectedConsumers.length>0)?false:true}
                                title={(this.props.selectedAmount>0 &&
                                    this.props.selectedConsumers.length>0)?'Pay Now':'Disabled'}>Pay Now</button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage },
        miscReduce: { agentInfo, selectedConsumers, selectedAmount } }
) => ({
    errorMessage, agentInfo, selectedConsumers, selectedAmount
});

export default connect(mapStateToProps, null)(TotalBill);
